import type { Epic } from '../../index.js'
import { Actions } from '../../Slice/index.js'
import { visualizationSlice } from '../../Slice/Visualization/VisualizationSlice.js'
import { catchError, filter, merge, mergeMap, of, takeUntil } from 'rxjs'
import { getWorkspaceState } from '../../../Repository/Visualization/WorkspaceStates.js'
import { SavedVizSchema } from '../../../View/Component/ConfigurableVisualization/Persistence/Verification.js'
import type { SavedViz } from '../../../View/Component/ConfigurableVisualization/Persistence/SavedViz.js'

export const loadRemoteViewEpic: Epic = (action$) => {
  const v = Actions[visualizationSlice.name]
  return action$.pipe(
    filter(v.remoteLoadRequest.match),
    mergeMap((a) =>
      getWorkspaceState(a.payload.id).pipe(
        takeUntil(action$.pipe(filter(v.setScope.match))),
        mergeMap((res) => {
          const parsed = SavedVizSchema.safeParse(res.state)

          if (!parsed.success) {
            console.error('Invalid snapshot: ', parsed.error)
            console.error('Snapshot: ', res.state)
          }

          if (!parsed.success) return of(v.remoteLoadFailure({ error: 'Invalid snapshot' }))

          const asTemplate = !!a.payload.asTemplate

          return merge(
            of(visualizationSlice.actions.setRestoring({ restoring: true })),
            of(
              visualizationSlice.actions.loadSavedViz({
                saved: parsed.data as SavedViz,
                asTemplate,
                type: 'LoadSavedVizAction'
              })
            ),
            of(visualizationSlice.actions.setRestoring({ restoring: false }))
          )
        }),
        catchError((e) => of(v.remoteLoadFailure({ error: String(e) })))
      )
    )
  )
}
